import {App} from "vue";
import {Windows, windows} from "./window/Windows";
import ScPage from "./page/ScPage.vue";
import ScBtn from "./widget/ScBtn.vue";
import ScSearch from "@/components/common/widget/ScSearch.vue";
import ScWindows from "@/components/common/window/ScWindows.vue";
import ScTree from "@/components/common/tree/ScTree.vue";
import {request} from "@/util/request";
import {Icon} from "@/components/common/Icon";

declare module 'vue' {
    export interface ComponentCustomProperties {
        $windows: Windows;
        $request: typeof request;
    }
}

export default {
    install(app: App) {
        // 安装windows
        app.component("ScWindows", ScWindows);
        app.config.globalProperties.$windows = windows;
        app.config.globalProperties.$request = request;
        // 使用useRouter及useRoute获取router和route;
        app.config.globalProperties.$router = undefined as any;

        app.component("ScIcon", Icon);
        app.component("ScPage", ScPage);
        app.component("ScTree", ScTree);
        app.component("ScBtn", ScBtn);
        app.component("ScSearch", ScSearch);
    },
};
